module.exports = __webpack_public_path__ + "img/icon_mine_share.b0edd2b6.png";